<template>
  <div class="domain-coverage">
    <div class="domain-coverage-item">
      <div class="item-title">生命科技</div>
      <div class="item-detail">
        <div v-for="(item, index) in displayLifeScience" :key="index" class="detail-row detail-row-theme1">{{item}}</div>
      </div>
    </div>
    <div class="domain-coverage-item">
      <div class="item-title">绿色科技</div>
      <div class="item-detail">
        <div v-for="(item, index) in displayGreenTechnology" :key="index" class="detail-row detail-row-theme2">{{item}}</div>
      </div>
    </div>
    <div class="domain-coverage-item">
      <div class="item-title">数智科技</div>
      <div class="item-detail">
        <div v-for="(item, index) in displayShuzhiTechnology" :key="index" class="detail-row detail-row-theme3">{{item}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajax } from "@/config/ppm-request.js";
export default {
  name: "domain-coverage",
  data() {
    return {
      lifeScience: [],
      greenTechnology: [],
      shuzhiTechnology: [],
      lifeScienceIndex: 0,
      greenTechnologyIndex: 0,
      shuzhiTechnologyIndex: 0,
      displayTimer: null,
      refreshTimer: null
    };
  },
  computed: {
    displayLifeScience() {
      return this.getDisplayItems(this.lifeScience, this.lifeScienceIndex);
    },
    displayGreenTechnology() {
      return this.getDisplayItems(this.greenTechnology, this.greenTechnologyIndex);
    },
    displayShuzhiTechnology() {
      return this.getDisplayItems(this.shuzhiTechnology, this.shuzhiTechnologyIndex);
    }
  },
  mounted() {
    this.fetchData();
    this.startTimers();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    async fetchData() {
      try {
        const res = await ajax.get("/zsck/bi/getDomainCovered");
        console.log("Domain Coverage Data:", res);
        this.lifeScience = res['生命科技'] || [];
        this.greenTechnology = res['绿色科技'] || [];
        this.shuzhiTechnology = res['数智科技'] || [];
        // 重置索引
        this.lifeScienceIndex = 0;
        this.greenTechnologyIndex = 0;
        this.shuzhiTechnologyIndex = 0;
      } catch (error) {
        console.error("Error fetching domain coverage data:", error);
      }
    },
    getDisplayItems(items, startIndex) {
      const maxDisplay = 7;
      if (items.length <= maxDisplay) {
        return items;
      }
      
      const displayItems = [];
      for (let i = 0; i < maxDisplay; i++) {
        const index = (startIndex + i) % items.length;
        displayItems.push(items[index]);
      }
      return displayItems;
    },
    rotateDisplay() {
      // 每15秒轮换一次显示内容
      if (this.lifeScience.length > 7) {
        this.lifeScienceIndex = (this.lifeScienceIndex + 7) % this.lifeScience.length;
      }
      if (this.greenTechnology.length > 7) {
        this.greenTechnologyIndex = (this.greenTechnologyIndex + 7) % this.greenTechnology.length;
      }
      if (this.shuzhiTechnology.length > 7) {
        this.shuzhiTechnologyIndex = (this.shuzhiTechnologyIndex + 7) % this.shuzhiTechnology.length;
      }
    },
    startTimers() {
      // 每15秒轮换显示内容
      this.displayTimer = setInterval(() => {
        this.rotateDisplay();
      }, 15000);
      
      // 每60秒重新请求接口
      this.refreshTimer = setInterval(() => {
        this.fetchData();
      }, 60000);
    },
    clearTimers() {
      if (this.displayTimer) {
        clearInterval(this.displayTimer);
        this.displayTimer = null;
      }
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.domain-coverage {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 0 2% 4%;
  display: flex;
  .domain-coverage-item {
    width: 30%;
    height: 100%;
    margin-right: 2%;
    background: linear-gradient(150deg, #1fa6fa4d 27.66%, #1fa6fa00 97.22%);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .item-title {
      width: 100%;
      color: #fff;
      height: 2.5rem;
      background: linear-gradient(77deg, #1fa6fa4d 10.91%, #1fa6fa00 105.12%);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .item-detail {
      flex: 1;
      overflow: hidden;
      .detail-row {
        width: 76%;
        margin: 0 12%;
        height: 1rem;
        overflow: hidden;
        margin-top: 0.8rem;
        font-size: 0.8rem;
        line-height: 1rem;
        text-align: center;
        font-weight: 600;
        border-radius: 0.25rem;
      }
      .detail-row-theme1 {
        color: #0683ff;
        border: 0.1rem solid #116ac3;
      }
      .detail-row-theme2 {
         color: #24a9c7;
        border: 1.88px solid #24a9c7;
      }
      .detail-row-theme3 {
        color: #836fe8;
        border: 1.88px solid #836fe8;
      }
    }
  }
}
</style>